/* tslint:disable */
/* eslint-disable */
/**
 * Wallet API
 * Endpoints to fetch offers in wallet (deals, incentives, and carrot cash) for users
 *
 * The version of the OpenAPI document: v0p12
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
export interface DiscountFailure {
    'message'?: string;
    'WalletError': WalletErrorEnum;
}


/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export interface FlightSearchRequest {
    'tripId': string;
    'fareId'?: string;
    'ProductSearchRequest': ProductSearchRequestEnum;
}


/**
 * productSearchRequest defines how to query a selected trip, eg. tripId for Flights
 * @export
 * @interface GetApplicableWalletOffersRequest
 */
export interface GetApplicableWalletOffersRequest {
    'productSearchRequest': ProductSearchRequest;
}
/**
 * @type GetApplicableWalletOffersResponse
 * @export
 */
export type GetApplicableWalletOffersResponse = { GetApplicableWalletOffersResponse: 'Failure' } & GetApplicableWalletOffersResponseFailure | { GetApplicableWalletOffersResponse: 'Success' } & GetApplicableWalletOffersResponseSuccess;

export const GetApplicableWalletOffersResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GetApplicableWalletOffersResponseEnum = typeof GetApplicableWalletOffersResponseEnum[keyof typeof GetApplicableWalletOffersResponseEnum];


/**
 * @type GetApplicableWalletOffersResponseFailure
 * @export
 */
export type GetApplicableWalletOffersResponseFailure = { Failure: 'Unknown' } & GetApplicableWalletOffersResponseUnknown;

export const GetApplicableWalletOffersResponseFailureEnum = {
    Unknown: 'Unknown'
} as const;

export type GetApplicableWalletOffersResponseFailureEnum = typeof GetApplicableWalletOffersResponseFailureEnum[keyof typeof GetApplicableWalletOffersResponseFailureEnum];


export interface GetApplicableWalletOffersResponseSuccess {
    'offerChoiceResponse': OfferChoiceResponse;
    'GetApplicableWalletOffersResponse': GetApplicableWalletOffersResponseEnum;
}


export interface GetApplicableWalletOffersResponseUnknown {
    'message': string;
    'Failure': GetApplicableWalletOffersResponseFailureEnum;
    'GetApplicableWalletOffersResponse': GetApplicableWalletOffersResponseEnum;
}


export interface GetUserCreditBalanceResponseSuccess {
    'creditBalance': Prices;
}
/**
 * @type GetUserWalletOffersResponse
 * @export
 */
export type GetUserWalletOffersResponse = { GetUserWalletOffersResponse: 'Failure' } & GetUserWalletOffersResponseFailure | { GetUserWalletOffersResponse: 'Success' } & GetUserWalletOffersResponseSuccess;

export const GetUserWalletOffersResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GetUserWalletOffersResponseEnum = typeof GetUserWalletOffersResponseEnum[keyof typeof GetUserWalletOffersResponseEnum];


/**
 * @type GetUserWalletOffersResponseFailure
 * @export
 */
export type GetUserWalletOffersResponseFailure = { Failure: 'Unknown' } & GetUserWalletOffersResponseUnknown;

export const GetUserWalletOffersResponseFailureEnum = {
    Unknown: 'Unknown'
} as const;

export type GetUserWalletOffersResponseFailureEnum = typeof GetUserWalletOffersResponseFailureEnum[keyof typeof GetUserWalletOffersResponseFailureEnum];


export interface GetUserWalletOffersResponseSuccess {
    'offers': Array<WalletOffer>;
    'GetUserWalletOffersResponse': GetUserWalletOffersResponseEnum;
}


export interface GetUserWalletOffersResponseUnknown {
    'message': string;
    'Failure': GetUserWalletOffersResponseFailureEnum;
    'GetUserWalletOffersResponse': GetUserWalletOffersResponseEnum;
}


export interface LodgingSearchRequest {
    'opaqueProductChoice': string;
    'ProductSearchRequest': ProductSearchRequestEnum;
}


export interface OfferChoiceResponse {
    'bestOfferOverall'?: WalletOffer;
    'creditOffer'?: WalletOffer;
    'offers': Array<WalletOffer>;
}
export interface OfferContent {
    'name': string;
    'shopPageBanner'?: string;
    'walletContent'?: WalletContent;
    'lineItemDescription': string;
    'availabilityPageBanner'?: string;
    'termsAndConditions'?: string;
    'landingPageBanner'?: string;
}
export interface OfferNotFound {
    'WalletError': WalletErrorEnum;
}


export const OfferType = {
    Cashback: 'Cashback',
    Credit: 'Credit',
    FirstIncentive: 'FirstIncentive',
    FlashDeal: 'FlashDeal',
    MembersOnly: 'MembersOnly',
    Promotion: 'Promotion',
    SubscriptionPremium: 'SubscriptionPremium'
} as const;

export type OfferType = typeof OfferType[keyof typeof OfferType];


/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
/**
 * @type ProductSearchRequest
 * @export
 */
export type ProductSearchRequest = { ProductSearchRequest: 'FlightSearchRequest' } & FlightSearchRequest | { ProductSearchRequest: 'LodgingSearchRequest' } & LodgingSearchRequest;

export const ProductSearchRequestEnum = {
    FlightSearchRequest: 'FlightSearchRequest',
    LodgingSearchRequest: 'LodgingSearchRequest'
} as const;

export type ProductSearchRequestEnum = typeof ProductSearchRequestEnum[keyof typeof ProductSearchRequestEnum];


export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface WalletContent {
    'title': string;
    'subtitle': string;
    'items': Array<string>;
    'illustrationUrl'?: string;
}
/**
 * @type WalletError
 * @export
 */
export type WalletError = { WalletError: 'DiscountFailure' } & DiscountFailure | { WalletError: 'OfferNotFound' } & OfferNotFound | { WalletError: 'WalletErrorErrorCode' } & WalletErrorErrorCode;

export const WalletErrorEnum = {
    DiscountFailure: 'DiscountFailure',
    OfferNotFound: 'OfferNotFound',
    WalletErrorErrorCode: 'WalletErrorErrorCode'
} as const;

export type WalletErrorEnum = typeof WalletErrorEnum[keyof typeof WalletErrorEnum];


export interface WalletErrorErrorCode {
    'code': string;
    'message'?: string;
    'WalletError': WalletErrorEnum;
}


export const WalletFunnel = {
    Air: 'Air',
    Lodging: 'Lodging'
} as const;

export type WalletFunnel = typeof WalletFunnel[keyof typeof WalletFunnel];


export interface WalletOffer {
    /**
     * Percentage discount amount for percentage offer
     * @type {number}
     * @memberof WalletOffer
     */
    'percentage'?: number;
    'offerContent': OfferContent;
    'funnels': Array<WalletFunnel>;
    'offerType': OfferType;
    'amount': Prices;
    'expiresOn': string;
    'id': string;
    'trackingPropertiesV2': TrackingProperties;
    'offerChoice': string;
    'maxDiscountAmount'?: Prices;
}


/**
 * Details on a Promotion discount applied to an order
 * @export
 * @interface WalletPayment
 */
export interface WalletPayment {
    'offerId'?: string;
    'name'?: string;
    'totalDiscountAmount': Prices;
    'paymentType': WalletPaymentType;
}


export const WalletPaymentType = {
    Credit: 'Credit',
    Promotion: 'Promotion'
} as const;

export type WalletPaymentType = typeof WalletPaymentType[keyof typeof WalletPaymentType];


/**
 * Request to add promotion to an order.
 * @export
 * @interface WalletPaymentUpdate
 */
export interface WalletPaymentUpdate {
    'offerId'?: string;
    'offerChoice'?: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve applicable vouchers from Scranton. This retrieves all active Scranton voucher offers for the  applicable search request (eg TripId for Flight vouchers) 
         * @param {GetApplicableWalletOffersRequest} getApplicableWalletOffersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WalletApplicablePost: async (getApplicableWalletOffersRequest: GetApplicableWalletOffersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getApplicableWalletOffersRequest' is not null or undefined
            assertParamExists('apiV0WalletApplicablePost', 'getApplicableWalletOffersRequest', getApplicableWalletOffersRequest)
            const localVarPath = `/api/v0/wallet/applicable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication csrfAuth required
            await setApiKeyToObject(localVarHeaderParameter, "H_CSRF_TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getApplicableWalletOffersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve user credit balance from Scranton
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WalletUserBalanceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/wallet/user/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication csrfAuth required
            await setApiKeyToObject(localVarHeaderParameter, "H_CSRF_TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve user vouchers from Scranton. This retrieves all active user targeted Scranton voucher offers.|
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WalletUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/wallet/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication csrfAuth required
            await setApiKeyToObject(localVarHeaderParameter, "H_CSRF_TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve applicable vouchers from Scranton. This retrieves all active Scranton voucher offers for the  applicable search request (eg TripId for Flight vouchers) 
         * @param {GetApplicableWalletOffersRequest} getApplicableWalletOffersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0WalletApplicablePost(getApplicableWalletOffersRequest: GetApplicableWalletOffersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicableWalletOffersResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0WalletApplicablePost(getApplicableWalletOffersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve user credit balance from Scranton
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0WalletUserBalanceGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserCreditBalanceResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0WalletUserBalanceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve user vouchers from Scranton. This retrieves all active user targeted Scranton voucher offers.|
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0WalletUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserWalletOffersResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0WalletUserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Retrieve applicable vouchers from Scranton. This retrieves all active Scranton voucher offers for the  applicable search request (eg TripId for Flight vouchers) 
         * @param {GetApplicableWalletOffersRequest} getApplicableWalletOffersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WalletApplicablePost(getApplicableWalletOffersRequest: GetApplicableWalletOffersRequest, options?: any): AxiosPromise<GetApplicableWalletOffersResponseSuccess> {
            return localVarFp.apiV0WalletApplicablePost(getApplicableWalletOffersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve user credit balance from Scranton
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WalletUserBalanceGet(options?: any): AxiosPromise<GetUserCreditBalanceResponseSuccess> {
            return localVarFp.apiV0WalletUserBalanceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve user vouchers from Scranton. This retrieves all active user targeted Scranton voucher offers.|
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WalletUserGet(options?: any): AxiosPromise<GetUserWalletOffersResponseSuccess> {
            return localVarFp.apiV0WalletUserGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Retrieve applicable vouchers from Scranton. This retrieves all active Scranton voucher offers for the  applicable search request (eg TripId for Flight vouchers) 
     * @param {GetApplicableWalletOffersRequest} getApplicableWalletOffersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0WalletApplicablePost(getApplicableWalletOffersRequest: GetApplicableWalletOffersRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0WalletApplicablePost(getApplicableWalletOffersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve user credit balance from Scranton
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0WalletUserBalanceGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0WalletUserBalanceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve user vouchers from Scranton. This retrieves all active user targeted Scranton voucher offers.|
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0WalletUserGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0WalletUserGet(options).then((request) => request(this.axios, this.basePath));
    }
}


